function getElementById(id: string | null): HTMLElement | null {
  if (!id) return null;
  const element = document.getElementById(id);
  if (!element) window.requestAnimationFrame(() => getElementById(id));
  return element;
}

export default getElementById;
